import { render, staticRenderFns } from "./PDF.vue?vue&type=template&id=5f8fdbf8&scoped=true&"
import script from "./PDF.vue?vue&type=script&lang=js&"
export * from "./PDF.vue?vue&type=script&lang=js&"
import style0 from "./PDF.vue?vue&type=style&index=0&id=5f8fdbf8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f8fdbf8",
  null
  
)

export default component.exports